<template>
<div class="positionSticky64">
	<div class="container container--narrow">
		<div class="subtabs questions-tab-scrollable">
				<div ref="questionTab" class="mdc-tab-bar main-tabs" role="tablist">
					<div class="mdc-tab-scroller">
						<div class="mdc-tab-scroller__scroll-area">
              <swiper ref="mySwiper" :options="swiperOption" class="main-swiper-navi pdx-4">
                <swiper-slide  v-for="(tab, index) in tabs.data" v-bind:key="index" class="swiper-slide">
							<div class="mdc-tab-scroller__scroll-content justify-content-center">
                <div tabindex="0" @click="!isCurrentQuestion(tab.questionId) ? moveQuestion(tab) : null" @keypress="!isCurrentQuestion(tab.questionId) ? moveQuestion(tab) : null">
                <button :disabled="isSequential(tab)" aria-selected="true" role="tab"
                        v-bind:class="['mdc-tab', { 'mdc-tab--active' : tab.questionId === currentQuestion.id  || tab.questionId === currentQuestion.questionId }]">
                  <span class="mdc-tab__content">
                    <span class="mdc-tab__text-label">
                      <div class="t-subtitle2" >
                        <div :class="!tab.isCheckButton ? 't-color-headlineBlack': 't-line-through-gray t-color-quizBlueGray'">{{index+1}}</div>
                      </div>
                    </span>
                  </span>
                  <span v-bind:class="['mdc-tab-indicator', { 'mdc-tab-indicator--active' : tab.questionId === currentQuestion.id  || tab.questionId === currentQuestion.questionId }]">
                    <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                  </span>
                  <span class="mdc-tab__ripple"></span>
                </button>
                </div>
              </div>
                </swiper-slide>
              </swiper>
						</div>
					</div>
				</div>
		</div>
	</div>
	<div class="divider divider-subtabs"></div>
</div>
</template>

<script>
/**
 * 시험 응시 문항 네비게이션 컴포넌트(exam take question navigation component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTabBar, MDCTabBarFoundation} from '@material/tab-bar';
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
	props: ['solves', 'questionSequence', 'currentQuestion'],

	data() {
		return {
			questionTab: null,
			tabs : {
				currentTab : 0,
				data : this.solves
			},
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 10,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        translate: 0,
        autoHeight: false,
      },
		}
	},

  components: {
    swiper,
    swiperSlide,
  },

  computed: {
    isSequence() {
      return this.questionSequence === 'SEQUENTIAL';
    },

    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },

	watch:{
		$route(to, from) {
			this.questionTab = new MDCTabBar(this.$refs.questionTab)
		},
	},

	mounted() {
		this.questionTab = new MDCTabBar(this.$refs.questionTab)
	},

	methods: {
		// 문항 이동(move question)
		setSolves(){
			this.tabs.data = this.solves
		},

		moveQuestion(solve) {
      if(this.isSequential(solve) && solve.isCheckButton === false) {
        this.alertDialog();
      } else {
        this.$emit('selectQuestionNavi', solve)
      }
		},

    isSequential(tab) {
      if(this.isSequence && tab.isCheckButton === false) {
        return true;
      } else {
        return false;
      }
    },

    alertDialog() {
      this.$alert({
        title: this.$t('990'),  //문항 풀이 후 다음 문항으로 이동할 수 있습니다.
        content: this.$t('991') + this.$t('992'),   //이 시험은 문항을 순차적으로 풀이해야 합니다. 문항을 풀이하고 다음 문항으로 이동해주세요.
        accept:  this.$t('993') //확인
      }).then(() => {})
    },

		isCurrentQuestion(questionId) {
			return questionId === this.currentQuestion.id
		}
	},
}
</script>

<style scoped>
.main-swiper-navi .swiper-slide {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 35px;
  /*width: 25px !important;*/
}
</style>
